import { liftPlanUEService } from '@/services/lift-plan-ue/lift-plan-ue-service';
import { projectKeys } from '@/utils/queryKeys';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import type { models } from 'cesg-shared';

export const useLiftPlanUEUpdateMutation = (projectId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['liftPlanUEService', 'put', projectId],
    mutationFn: ({
      liftPlanId,
      body,
    }: {
      liftPlanId: string;
      body: models.PutLiftPlanUEBody;
    }) => liftPlanUEService.put(projectId, liftPlanId, body),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: projectKeys.liftPlanUE({ projectId }) }),
  });
};
